/// <amd-module name="TFS/Admin/Common/RestClient/Identities" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\identity.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import * as Identities from "../Contracts/Identities";
import * as VS_DelegatedAuthorization from "VSS/Platform/Contracts/DelegatedAuthorization";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface IIdentitiesRestClient extends IVssRestClient {
    /**
     * @param sourceIdentity - 
     */
    createOrBindWithClaims(sourceIdentity: Identities.Identity): Promise<Identities.Identity>;
    /**
     * @param id - 
     * @param isMasterId - 
     */
    getDescriptorById(id: string, isMasterId?: boolean): Promise<Identities.IdentityDescriptor>;
    /**
     * @param container - 
     */
    createGroups(container: any): Promise<Identities.Identity[]>;
    /**
     * @param groupId - 
     */
    deleteGroup(groupId: string): Promise<void>;
    /**
     * @param scopeIds - 
     * @param recurse - 
     * @param deleted - 
     * @param properties - 
     */
    listGroups(scopeIds?: string, recurse?: boolean, deleted?: boolean, properties?: string): Promise<Identities.Identity[]>;
    /**
     * @param identitySequenceId - 
     * @param groupSequenceId - 
     * @param organizationIdentitySequenceId - 
     * @param pageSize - 
     * @param scopeId - 
     */
    getIdentityChanges(identitySequenceId: number, groupSequenceId: number, organizationIdentitySequenceId?: number, pageSize?: number, scopeId?: string): Promise<Identities.ChangedIdentities>;
    /**
     * @param domainId - 
     */
    getUserIdentityIdsByDomainId(domainId: string): Promise<string[]>;
    /**
     * Resolve legacy identity information for use with older APIs such as the Security APIs
     * 
     * @param descriptors - A comma separated list of identity descriptors to resolve
     * @param identityIds - A comma seperated list of storage keys to resolve
     * @param subjectDescriptors - A comma seperated list of subject descriptors to resolve
     * @param socialDescriptors - 
     * @param searchFilter - The type of search to perform. Values can be AccountName (domain\\alias), DisplayName, MailAddress, General (display name, account name, or unique name), or LocalGroupName (only search Azure Devops groups).
     * @param filterValue - The search value, as specified by the searchFilter.
     * @param queryMembership - The membership information to include with the identities. Values can be None for no membership data or Direct to include the groups that the identity is a member of and the identities that are a member of this identity (groups only)
     * @param properties - 
     * @param includeRestrictedVisibility - 
     * @param options - 
     */
    readIdentities(descriptors?: string, identityIds?: string, subjectDescriptors?: string, socialDescriptors?: string, searchFilter?: string, filterValue?: string, queryMembership?: Identities.QueryMembership, properties?: string, includeRestrictedVisibility?: boolean, options?: Identities.ReadIdentitiesOptions): Promise<Identities.Identity[]>;
    /**
     * @param scopeId - 
     * @param queryMembership - 
     * @param properties - 
     */
    readIdentitiesByScope(scopeId: string, queryMembership?: Identities.QueryMembership, properties?: string): Promise<Identities.Identity[]>;
    /**
     * @param identityId - 
     * @param queryMembership - 
     * @param properties - 
     */
    readIdentity(identityId: string, queryMembership?: Identities.QueryMembership, properties?: string): Promise<Identities.Identity>;
    /**
     * @param identities - 
     * @param allowMetaDataUpdate - 
     */
    updateIdentities(identities: VS_Services.VssJsonCollectionWrapperV<Identities.Identity[]>, allowMetaDataUpdate?: boolean): Promise<Identities.IdentityUpdateData[]>;
    /**
     * @param identity - 
     * @param identityId - 
     */
    updateIdentity(identity: Identities.Identity, identityId: string): Promise<void>;
    /**
     * @param frameworkIdentityInfo - 
     */
    createIdentity(frameworkIdentityInfo: Identities.FrameworkIdentityInfo): Promise<Identities.Identity>;
    /**
     * @param batchInfo - 
     */
    readIdentityBatch(batchInfo: Identities.IdentityBatchInfo): Promise<Identities.Identity[]>;
    /**
     * @param scopeId - 
     */
    getIdentitySnapshot(scopeId: string): Promise<Identities.IdentitySnapshot>;
    /**
     * Read the max sequence id of all the identities.
     * 
     */
    getMaxSequenceId(): Promise<number>;
    /**
     * Read identity of the home tenant request user.
     * 
     */
    getSelf(): Promise<Identities.IdentitySelf>;
    /**
     * @param containerId - 
     * @param memberId - 
     */
    addMember(containerId: string, memberId: string): Promise<boolean>;
    /**
     * @param containerId - 
     * @param memberId - 
     * @param forceRemove - 
     */
    forceRemoveMember(containerId: string, memberId: string, forceRemove: boolean): Promise<boolean>;
    /**
     * @param containerId - 
     * @param memberId - 
     * @param queryMembership - 
     */
    readMember(containerId: string, memberId: string, queryMembership?: Identities.QueryMembership): Promise<Identities.IdentityDescriptor>;
    /**
     * @param containerId - 
     * @param queryMembership - 
     */
    readMembers(containerId: string, queryMembership?: Identities.QueryMembership): Promise<Identities.IdentityDescriptor[]>;
    /**
     * @param containerId - 
     * @param memberId - 
     */
    removeMember(containerId: string, memberId: string): Promise<boolean>;
    /**
     * @param memberId - 
     * @param containerId - 
     * @param queryMembership - 
     */
    readMemberOf(memberId: string, containerId: string, queryMembership?: Identities.QueryMembership): Promise<Identities.IdentityDescriptor>;
    /**
     * @param memberId - 
     * @param queryMembership - 
     */
    readMembersOf(memberId: string, queryMembership?: Identities.QueryMembership): Promise<Identities.IdentityDescriptor[]>;
    /**
     * @param memberId - 
     * @param queryMembership - 
     */
    refreshMembersOf(memberId: string, queryMembership?: Identities.QueryMembership): Promise<Identities.IdentityDescriptor[]>;
    /**
     * @param identityRightsTransferData - 
     */
    transferIdentityRightsBatch(identityRightsTransferData: Identities.IdentityRightsTransferData): Promise<void>;
    /**
     * @param info - 
     * @param scopeId - 
     */
    createScope(info: Identities.CreateScopeInfo, scopeId: string): Promise<Identities.IdentityScope>;
    /**
     * @param scopeId - 
     */
    deleteScope(scopeId: string): Promise<void>;
    /**
     * @param scopeId - 
     */
    getScopeById(scopeId: string): Promise<Identities.IdentityScope>;
    /**
     * @param scopeName - 
     */
    getScopeByName(scopeName: string): Promise<Identities.IdentityScope>;
    /**
     * @param patchDocument - 
     * @param scopeId - 
     */
    updateScope(patchDocument: VS_Services.JsonPatchDocument, scopeId: string): Promise<void>;
    /**
     */
    getSignedInToken(): Promise<VS_DelegatedAuthorization.AccessTokenResult>;
    /**
     */
    getSignoutToken(): Promise<VS_DelegatedAuthorization.AccessTokenResult>;
    /**
     * @param info - 
     */
    swapIdentity(info: Identities.SwapIdentityInfo): Promise<void>;
    /**
     * @param tenantId - 
     */
    getTenant(tenantId: string): Promise<Identities.TenantInfo>;
    /**
     * @param continuationToken - 
     * @param scopeDescriptor - 
     */
    listUsers(continuationToken?: string, scopeDescriptor?: string): Promise<Identities.PagedIdentities>;
}

class IdentitiesRestClient extends RestClientBase implements IIdentitiesRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param sourceIdentity - 
     */
    public async createOrBindWithClaims(
        sourceIdentity: Identities.Identity
        ): Promise<Identities.Identity> {

        return this.beginRequest<Identities.Identity>({
            apiVersion: "6.1-preview.1",
            method: "PUT",
            routeTemplate: "_apis/identities/Claims",
            body: sourceIdentity
        });
    }

    /**
     * @param id - 
     * @param isMasterId - 
     */
    public async getDescriptorById(
        id: string,
        isMasterId?: boolean
        ): Promise<Identities.IdentityDescriptor> {

        const queryValues: any = {
            isMasterId: isMasterId
        };

        return this.beginRequest<Identities.IdentityDescriptor>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/identities/descriptors/{id}",
            routeValues: {
                id: id
            },
            queryParams: queryValues
        });
    }

    /**
     * @param container - 
     */
    public async createGroups(
        container: any
        ): Promise<Identities.Identity[]> {

        return this.beginRequest<Identities.Identity[]>({
            apiVersion: "6.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/Groups/{groupId}",
            body: container
        });
    }

    /**
     * @param groupId - 
     */
    public async deleteGroup(
        groupId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "6.1-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Groups/{groupId}",
            routeValues: {
                groupId: groupId
            }
        });
    }

    /**
     * @param scopeIds - 
     * @param recurse - 
     * @param deleted - 
     * @param properties - 
     */
    public async listGroups(
        scopeIds?: string,
        recurse?: boolean,
        deleted?: boolean,
        properties?: string
        ): Promise<Identities.Identity[]> {

        const queryValues: any = {
            scopeIds: scopeIds,
            recurse: recurse,
            deleted: deleted,
            properties: properties
        };

        return this.beginRequest<Identities.Identity[]>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/Groups/{groupId}",
            queryParams: queryValues
        });
    }

    /**
     * @param identitySequenceId - 
     * @param groupSequenceId - 
     * @param organizationIdentitySequenceId - 
     * @param pageSize - 
     * @param scopeId - 
     */
    public async getIdentityChanges(
        identitySequenceId: number,
        groupSequenceId: number,
        organizationIdentitySequenceId?: number,
        pageSize?: number,
        scopeId?: string
        ): Promise<Identities.ChangedIdentities> {

        const queryValues: any = {
            identitySequenceId: identitySequenceId,
            groupSequenceId: groupSequenceId,
            organizationIdentitySequenceId: organizationIdentitySequenceId,
            pageSize: pageSize,
            scopeId: scopeId
        };

        return this.beginRequest<Identities.ChangedIdentities>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/Identities/{identityId}",
            queryParams: queryValues
        });
    }

    /**
     * @param domainId - 
     */
    public async getUserIdentityIdsByDomainId(
        domainId: string
        ): Promise<string[]> {

        const queryValues: any = {
            domainId: domainId
        };

        return this.beginRequest<string[]>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/Identities/{identityId}",
            queryParams: queryValues
        });
    }

    /**
     * Resolve legacy identity information for use with older APIs such as the Security APIs
     * 
     * @param descriptors - A comma separated list of identity descriptors to resolve
     * @param identityIds - A comma seperated list of storage keys to resolve
     * @param subjectDescriptors - A comma seperated list of subject descriptors to resolve
     * @param socialDescriptors - 
     * @param searchFilter - The type of search to perform. Values can be AccountName (domain\\alias), DisplayName, MailAddress, General (display name, account name, or unique name), or LocalGroupName (only search Azure Devops groups).
     * @param filterValue - The search value, as specified by the searchFilter.
     * @param queryMembership - The membership information to include with the identities. Values can be None for no membership data or Direct to include the groups that the identity is a member of and the identities that are a member of this identity (groups only)
     * @param properties - 
     * @param includeRestrictedVisibility - 
     * @param options - 
     */
    public async readIdentities(
        descriptors?: string,
        identityIds?: string,
        subjectDescriptors?: string,
        socialDescriptors?: string,
        searchFilter?: string,
        filterValue?: string,
        queryMembership?: Identities.QueryMembership,
        properties?: string,
        includeRestrictedVisibility?: boolean,
        options?: Identities.ReadIdentitiesOptions
        ): Promise<Identities.Identity[]> {

        const queryValues: any = {
            descriptors: descriptors,
            identityIds: identityIds,
            subjectDescriptors: subjectDescriptors,
            socialDescriptors: socialDescriptors,
            searchFilter: searchFilter,
            filterValue: filterValue,
            queryMembership: queryMembership,
            properties: properties,
            includeRestrictedVisibility: includeRestrictedVisibility,
            options: options
        };

        return this.beginRequest<Identities.Identity[]>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/Identities/{identityId}",
            queryParams: queryValues
        });
    }

    /**
     * @param scopeId - 
     * @param queryMembership - 
     * @param properties - 
     */
    public async readIdentitiesByScope(
        scopeId: string,
        queryMembership?: Identities.QueryMembership,
        properties?: string
        ): Promise<Identities.Identity[]> {

        const queryValues: any = {
            scopeId: scopeId,
            queryMembership: queryMembership,
            properties: properties
        };

        return this.beginRequest<Identities.Identity[]>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/Identities/{identityId}",
            queryParams: queryValues
        });
    }

    /**
     * @param identityId - 
     * @param queryMembership - 
     * @param properties - 
     */
    public async readIdentity(
        identityId: string,
        queryMembership?: Identities.QueryMembership,
        properties?: string
        ): Promise<Identities.Identity> {

        const queryValues: any = {
            queryMembership: queryMembership,
            properties: properties
        };

        return this.beginRequest<Identities.Identity>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/Identities/{identityId}",
            routeValues: {
                identityId: identityId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param identities - 
     * @param allowMetaDataUpdate - 
     */
    public async updateIdentities(
        identities: VS_Services.VssJsonCollectionWrapperV<Identities.Identity[]>,
        allowMetaDataUpdate?: boolean
        ): Promise<Identities.IdentityUpdateData[]> {

        const queryValues: any = {
            allowMetaDataUpdate: allowMetaDataUpdate
        };

        return this.beginRequest<Identities.IdentityUpdateData[]>({
            apiVersion: "6.1-preview.1",
            method: "PUT",
            routeTemplate: "_apis/Identities/{identityId}",
            queryParams: queryValues,
            body: identities
        });
    }

    /**
     * @param identity - 
     * @param identityId - 
     */
    public async updateIdentity(
        identity: Identities.Identity,
        identityId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "6.1-preview.1",
            method: "PUT",
            routeTemplate: "_apis/Identities/{identityId}",
            routeValues: {
                identityId: identityId
            },
            body: identity
        });
    }

    /**
     * @param frameworkIdentityInfo - 
     */
    public async createIdentity(
        frameworkIdentityInfo: Identities.FrameworkIdentityInfo
        ): Promise<Identities.Identity> {

        return this.beginRequest<Identities.Identity>({
            apiVersion: "6.1-preview.1",
            method: "PUT",
            routeTemplate: "_apis/identities/Identity",
            body: frameworkIdentityInfo
        });
    }

    /**
     * @param batchInfo - 
     */
    public async readIdentityBatch(
        batchInfo: Identities.IdentityBatchInfo
        ): Promise<Identities.Identity[]> {

        return this.beginRequest<Identities.Identity[]>({
            apiVersion: "6.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/IdentityBatch",
            body: batchInfo
        });
    }

    /**
     * @param scopeId - 
     */
    public async getIdentitySnapshot(
        scopeId: string
        ): Promise<Identities.IdentitySnapshot> {

        return this.beginRequest<Identities.IdentitySnapshot>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/IdentitySnapshot/{scopeId}",
            routeValues: {
                scopeId: scopeId
            }
        });
    }

    /**
     * Read the max sequence id of all the identities.
     * 
     */
    public async getMaxSequenceId(
        ): Promise<number> {

        return this.beginRequest<number>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/identities/MaxSequenceId"
        });
    }

    /**
     * Read identity of the home tenant request user.
     * 
     */
    public async getSelf(
        ): Promise<Identities.IdentitySelf> {

        return this.beginRequest<Identities.IdentitySelf>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/identities/me"
        });
    }

    /**
     * @param containerId - 
     * @param memberId - 
     */
    public async addMember(
        containerId: string,
        memberId: string
        ): Promise<boolean> {

        return this.beginRequest<boolean>({
            apiVersion: "6.1-preview.1",
            method: "PUT",
            routeTemplate: "_apis/identities/{containerId}/Members/{memberId}",
            routeValues: {
                containerId: containerId,
                memberId: memberId
            }
        });
    }

    /**
     * @param containerId - 
     * @param memberId - 
     * @param forceRemove - 
     */
    public async forceRemoveMember(
        containerId: string,
        memberId: string,
        forceRemove: boolean
        ): Promise<boolean> {

        const queryValues: any = {
            forceRemove: forceRemove
        };

        return this.beginRequest<boolean>({
            apiVersion: "6.1-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/identities/{containerId}/Members/{memberId}",
            routeValues: {
                containerId: containerId,
                memberId: memberId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param containerId - 
     * @param memberId - 
     * @param queryMembership - 
     */
    public async readMember(
        containerId: string,
        memberId: string,
        queryMembership?: Identities.QueryMembership
        ): Promise<Identities.IdentityDescriptor> {

        const queryValues: any = {
            queryMembership: queryMembership
        };

        return this.beginRequest<Identities.IdentityDescriptor>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/identities/{containerId}/Members/{memberId}",
            routeValues: {
                containerId: containerId,
                memberId: memberId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param containerId - 
     * @param queryMembership - 
     */
    public async readMembers(
        containerId: string,
        queryMembership?: Identities.QueryMembership
        ): Promise<Identities.IdentityDescriptor[]> {

        const queryValues: any = {
            queryMembership: queryMembership
        };

        return this.beginRequest<Identities.IdentityDescriptor[]>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/identities/{containerId}/Members/{memberId}",
            routeValues: {
                containerId: containerId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param containerId - 
     * @param memberId - 
     */
    public async removeMember(
        containerId: string,
        memberId: string
        ): Promise<boolean> {

        return this.beginRequest<boolean>({
            apiVersion: "6.1-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/identities/{containerId}/Members/{memberId}",
            routeValues: {
                containerId: containerId,
                memberId: memberId
            }
        });
    }

    /**
     * @param memberId - 
     * @param containerId - 
     * @param queryMembership - 
     */
    public async readMemberOf(
        memberId: string,
        containerId: string,
        queryMembership?: Identities.QueryMembership
        ): Promise<Identities.IdentityDescriptor> {

        const queryValues: any = {
            queryMembership: queryMembership
        };

        return this.beginRequest<Identities.IdentityDescriptor>({
            apiVersion: "6.1-preview.2",
            routeTemplate: "_apis/identities/{memberId}/MembersOf/{containerId}",
            routeValues: {
                memberId: memberId,
                containerId: containerId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param memberId - 
     * @param queryMembership - 
     */
    public async readMembersOf(
        memberId: string,
        queryMembership?: Identities.QueryMembership
        ): Promise<Identities.IdentityDescriptor[]> {

        const queryValues: any = {
            queryMembership: queryMembership
        };

        return this.beginRequest<Identities.IdentityDescriptor[]>({
            apiVersion: "6.1-preview.2",
            routeTemplate: "_apis/identities/{memberId}/MembersOf/{containerId}",
            routeValues: {
                memberId: memberId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param memberId - 
     * @param queryMembership - 
     */
    public async refreshMembersOf(
        memberId: string,
        queryMembership?: Identities.QueryMembership
        ): Promise<Identities.IdentityDescriptor[]> {

        const queryValues: any = {
            queryMembership: queryMembership
        };

        return this.beginRequest<Identities.IdentityDescriptor[]>({
            apiVersion: "6.1-preview.2",
            method: "POST",
            routeTemplate: "_apis/identities/{memberId}/MembersOf/{containerId}",
            routeValues: {
                memberId: memberId
            },
            queryParams: queryValues
        });
    }

    /**
     * @param identityRightsTransferData - 
     */
    public async transferIdentityRightsBatch(
        identityRightsTransferData: Identities.IdentityRightsTransferData
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "6.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/identities/Rights",
            body: identityRightsTransferData
        });
    }

    /**
     * @param info - 
     * @param scopeId - 
     */
    public async createScope(
        info: Identities.CreateScopeInfo,
        scopeId: string
        ): Promise<Identities.IdentityScope> {

        return this.beginRequest<Identities.IdentityScope>({
            apiVersion: "6.1-preview.2",
            method: "PUT",
            routeTemplate: "_apis/Scopes/{scopeId}",
            routeValues: {
                scopeId: scopeId
            },
            body: info
        });
    }

    /**
     * @param scopeId - 
     */
    public async deleteScope(
        scopeId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "6.1-preview.2",
            method: "DELETE",
            routeTemplate: "_apis/Scopes/{scopeId}",
            routeValues: {
                scopeId: scopeId
            }
        });
    }

    /**
     * @param scopeId - 
     */
    public async getScopeById(
        scopeId: string
        ): Promise<Identities.IdentityScope> {

        return this.beginRequest<Identities.IdentityScope>({
            apiVersion: "6.1-preview.2",
            routeTemplate: "_apis/Scopes/{scopeId}",
            routeValues: {
                scopeId: scopeId
            }
        });
    }

    /**
     * @param scopeName - 
     */
    public async getScopeByName(
        scopeName: string
        ): Promise<Identities.IdentityScope> {

        const queryValues: any = {
            scopeName: scopeName
        };

        return this.beginRequest<Identities.IdentityScope>({
            apiVersion: "6.1-preview.2",
            routeTemplate: "_apis/Scopes/{scopeId}",
            queryParams: queryValues
        });
    }

    /**
     * @param patchDocument - 
     * @param scopeId - 
     */
    public async updateScope(
        patchDocument: VS_Services.JsonPatchDocument,
        scopeId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "6.1-preview.2",
            method: "PATCH",
            routeTemplate: "_apis/Scopes/{scopeId}",
            routeValues: {
                scopeId: scopeId
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            body: patchDocument
        });
    }

    /**
     */
    public async getSignedInToken(
        ): Promise<VS_DelegatedAuthorization.AccessTokenResult> {

        return this.beginRequest<VS_DelegatedAuthorization.AccessTokenResult>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/SignedInToken"
        });
    }

    /**
     */
    public async getSignoutToken(
        ): Promise<VS_DelegatedAuthorization.AccessTokenResult> {

        return this.beginRequest<VS_DelegatedAuthorization.AccessTokenResult>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/SignoutToken"
        });
    }

    /**
     * @param info - 
     */
    public async swapIdentity(
        info: Identities.SwapIdentityInfo
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "6.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/identities/Swap",
            body: info
        });
    }

    /**
     * @param tenantId - 
     */
    public async getTenant(
        tenantId: string
        ): Promise<Identities.TenantInfo> {

        return this.beginRequest<Identities.TenantInfo>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/identities/tenant/{tenantId}",
            routeValues: {
                tenantId: tenantId
            }
        });
    }

    /**
     * @param continuationToken - 
     * @param scopeDescriptor - 
     */
    public async listUsers(
        continuationToken?: string,
        scopeDescriptor?: string
        ): Promise<Identities.PagedIdentities> {

        const queryValues: any = {
            continuationToken: continuationToken,
            scopeDescriptor: scopeDescriptor
        };

        return this.beginRequest<Response>({
            apiVersion: "6.1-preview.1",
            routeTemplate: "_apis/identities/Users",
            queryParams: queryValues,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const continuationTokenHeader = response.headers.get("X-MS-ContinuationToken");
            const result: Identities.PagedIdentities = {
                identities: <Identities.Identity[]>body,
                continuationToken: continuationTokenHeader ? continuationTokenHeader.split(',') : []
            };
            return result;
        });
    }

}

export const IdentitiesClientName = "Identities-AdminArea.IIdentitiesRestClient";

export function getIdentitiesClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IIdentitiesRestClient {
    return pageContext.getRestClient<IIdentitiesRestClient>(IdentitiesClientName, options);
}

RestClients.add(IdentitiesClientName, { 
    factory: IdentitiesRestClient,
    options: {
        serviceInstanceType: "951917ac-a960-4999-8464-e3f0aa25b381"
    }
});
